// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J5Yo6h {
  position: fixed;
  bottom: var(--spacing-2-5, 20px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  background: var(--success-green-light, #eaffe5);
  border: 1px solid var(--success-green, #387c2b);
  border-radius: var(--radius-s, 4px);
  box-shadow: var(--shadow-sm, 0px 1px 2px 0px rgba(0, 0, 0, 0.16));
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  min-width: 300px;
  max-width: 544px;
  animation: ykTVXa 0.3s ease-out;
}

.xfKQ3w {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
  padding: var(--spacing-0-5, 4px) 0px;
}

.aMHvL9 {
  width: 20px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--success-green, #387c2b);
}

.D2ZKde {
  margin: 0;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-regular, 400);
  color: var(--text-neutral-dark, #1f1f1f);
  line-height: var(--line-height-180, 1.8);
  flex: 1;
}

.gp1qSs {
  background: rgba(255, 255, 255, 0.01);
  border: 1px solid rgba(255, 255, 255, 0.01);
  border-radius: var(--radius-s, 4px);
  padding: var(--spacing-1, 8px);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  color: var(--success-green-dark, #224c1a);
  transition: background-color 0.2s ease;
}

.gp1qSs:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

@keyframes ykTVXa {
  from {
    transform: translateX(-50%) translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}

.HkpDWZ {
  top: var(--spacing-2-5, 20px);
  right: var(--spacing-2-5, 20px);
  bottom: auto;
  left: auto;
  transform: none;
  animation: _5bQja 0.3s ease-out;
}

@keyframes _5bQja {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .J5Yo6h {
    bottom: var(--spacing-1-25, 10px);
    left: var(--spacing-1-25, 10px);
    right: var(--spacing-1-25, 10px);
    transform: none;
    min-width: auto;
    max-width: none;
    animation: OKGmpH 0.3s ease-out;
  }

  @keyframes OKGmpH {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .HkpDWZ {
    top: var(--spacing-1-25, 10px);
    right: var(--spacing-1-25, 10px);
    left: auto;
    animation: TY2cj3 0.3s ease-out;
  }

  @keyframes TY2cj3 {
    from {
      transform: translateY(-100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Toast/Toast.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gCAAgC;EAChC,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,+CAA+C;EAC/C,+CAA+C;EAC/C,mCAAmC;EACnC,iEAAiE;EACjE,uDAAuD;EACvD,gBAAgB;EAChB,gBAAgB;EAChB,+BAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,iEAAiE;EACjE,oCAAoC;EACpC,4CAA4C;EAC5C,wCAAwC;EACxC,wCAAwC;EACxC,OAAO;AACT;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mCAAmC;EACnC,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,4CAA4C;IAC5C,UAAU;EACZ;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,YAAY;EACZ,UAAU;EACV,eAAe;EACf,+BAA0C;AAC5C;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,+BAA+B;IAC/B,gCAAgC;IAChC,eAAe;IACf,eAAe;IACf,eAAe;IACf,+BAAsC;EACxC;;EAEA;IACE;MACE,2BAA2B;MAC3B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;IAChC,UAAU;IACV,+BAAgD;EAClD;;EAEA;IACE;MACE,4BAA4B;MAC5B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;AACF","sourcesContent":[".toast {\n  position: fixed;\n  bottom: var(--spacing-2-5, 20px);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  background: var(--success-green-light, #eaffe5);\n  border: 1px solid var(--success-green, #387c2b);\n  border-radius: var(--radius-s, 4px);\n  box-shadow: var(--shadow-sm, 0px 1px 2px 0px rgba(0, 0, 0, 0.16));\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  min-width: 300px;\n  max-width: 544px;\n  animation: slideUp 0.3s ease-out;\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  padding: var(--spacing-0-5, 4px) 0px;\n}\n\n.icon {\n  width: 20px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: var(--success-green, #387c2b);\n}\n\n.message {\n  margin: 0;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  color: var(--text-neutral-dark, #1f1f1f);\n  line-height: var(--line-height-180, 1.8);\n  flex: 1;\n}\n\n.closeButton {\n  background: rgba(255, 255, 255, 0.01);\n  border: 1px solid rgba(255, 255, 255, 0.01);\n  border-radius: var(--radius-s, 4px);\n  padding: var(--spacing-1, 8px);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  color: var(--success-green-dark, #224c1a);\n  transition: background-color 0.2s ease;\n}\n\n.closeButton:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateX(-50%) translateY(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(-50%) translateY(0);\n    opacity: 1;\n  }\n}\n\n.toastTopRight {\n  top: var(--spacing-2-5, 20px);\n  right: var(--spacing-2-5, 20px);\n  bottom: auto;\n  left: auto;\n  transform: none;\n  animation: slideDownTopRight 0.3s ease-out;\n}\n\n@keyframes slideDownTopRight {\n  from {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .toast {\n    bottom: var(--spacing-1-25, 10px);\n    left: var(--spacing-1-25, 10px);\n    right: var(--spacing-1-25, 10px);\n    transform: none;\n    min-width: auto;\n    max-width: none;\n    animation: slideUpMobile 0.3s ease-out;\n  }\n\n  @keyframes slideUpMobile {\n    from {\n      transform: translateY(100%);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n\n  .toastTopRight {\n    top: var(--spacing-1-25, 10px);\n    right: var(--spacing-1-25, 10px);\n    left: auto;\n    animation: slideDownTopRightMobile 0.3s ease-out;\n  }\n\n  @keyframes slideDownTopRightMobile {\n    from {\n      transform: translateY(-100%);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toast": `J5Yo6h`,
	"slideUp": `ykTVXa`,
	"content": `xfKQ3w`,
	"icon": `aMHvL9`,
	"message": `D2ZKde`,
	"closeButton": `gp1qSs`,
	"toastTopRight": `HkpDWZ`,
	"slideDownTopRight": `_5bQja`,
	"slideUpMobile": `OKGmpH`,
	"slideDownTopRightMobile": `TY2cj3`
};
module.exports = ___CSS_LOADER_EXPORT___;
